import React from 'react';
import { useSeenOfferPixel } from 'hook/helper.hook';
import { getViewOfferTileCard } from 'helpers/tracking.helpers';
import { Link } from 'components/navigation/Link/Link';
import { Image } from 'components/Image/Image';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const MarketplaceOfferCard = ({ offerModulePosition, ...props }) => {
  let attributes = {
    moduleName: props.moduleName,
    modulePosition: props.modulePosition,
    offerModulePosition: offerModulePosition,
    cardName: props.cardName,
    vertical: props.verticalTracking,
  };

  let trackingAttributes = getViewOfferTileCard(attributes);

  const seenOffer = useSeenOfferPixel(trackingAttributes);
  return (
    <FlexContainer className={props.containerClasses}>
      <Link
        onClickCallback={props.onLinkClickEvent}
        datatestid="Overview-offer-carousel-link"
        to={props.url}
        location={props.location}
        extraEventAttributes={trackingAttributes}
        ariaLabel={props?.text}
      >
        <FlexContainer className="flex-column offer-card bgWhite padB20 padT10 padLR6">
          <FlexContainer className="FlexContainer flex-column justify-start items-align-center">
            <>
              <Image className={props.tileIconKey} />
              {seenOffer}
            </>
            <FlexContainer className="text-14 text-center fontGray400">
              {props.text}
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </Link>
    </FlexContainer>
  );
};

export default MarketplaceOfferCard;
